import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from "../../Context/auth";

// --- COMPONENTES DOS MODAIS (Mantidos como estavam) ---
const TamanhoModal = ({ isVisible, onClose, tamanhosData, onSave, gradeNome }) => {
    const [tamanhosEmEdicao, setTamanhosEmEdicao] = useState([]);

    useEffect(() => {
        setTamanhosEmEdicao(JSON.parse(JSON.stringify(Array.isArray(tamanhosData) ? tamanhosData : [])));
    }, [tamanhosData]);


    if (!isVisible) return null;

    const handleUpdateQtde = (idOuTamanho, newQtde) => {
        const qtde = Math.max(0, Number(newQtde.replace(/[^0-9]/g, '')));
        if (isNaN(qtde)) return;

        setTamanhosEmEdicao(prev => prev.map(item =>
            (item.id === idOuTamanho || item.tamanho === idOuTamanho) ? { ...item, quantidade: qtde } : item
        ));
    };

    const somatorio = tamanhosEmEdicao.reduce((sum, item) => sum + (Number(item.quantidade) || 0), 0);

    const handleSave = () => {
        onSave(tamanhosEmEdicao);
    };

    const modalStyle = {
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center',
        zIndex: 1060
    };
    const contentStyle = {
        backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '90%', maxWidth: '500px',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.5)'
    };


    return (
        <div style={modalStyle}>
            <div style={contentStyle}>
                <div className="modal-header d-flex justify-content-between align-items-center p-0 pb-2 border-bottom">
                    <h5 className="modal-title">Configurar Grade: {gradeNome}</h5>
                    <button type="button" className="btn-close" onClick={onClose}></button>
                </div>
                <div className="modal-body p-0 py-3" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <div className="d-flex justify-content-between mb-3 fw-bold border-bottom pb-1">
                        <span>Tamanho</span>
                        <span>Quantidade por Volume</span>
                    </div>
                    {tamanhosEmEdicao.map((item, index) => (
                        <div key={item.id || item.tamanho || index} className="d-flex justify-content-between align-items-center mb-2 p-2 border-bottom">
                            <span className="fw-bold">{item.tamanho}</span>
                            <input
                                type="number"
                                className="form-control form-control-sm text-center"
                                value={item.quantidade}
                                onChange={(e) => handleUpdateQtde(item.id || item.tamanho, e.target.value)}
                                min="0"
                                style={{ width: '80px' }}
                            />
                        </div>
                    ))}
                    {tamanhosEmEdicao.length === 0 && <p className='text-muted text-center'>Nenhum tamanho encontrado para esta grade.</p>}
                </div>
                <div className="modal-footer p-0 pt-3 border-top d-flex justify-content-between">
                    <span className="me-auto fw-bold">TOTAL POR VOLUME: {somatorio}</span>
                    <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                    <button type="button" className="btn btn-success" onClick={handleSave}>Confirmar</button>
                </div>
            </div>
        </div>
    );
};

const VisualizarGradeModal = ({ isVisible, onClose, tamanhosData = [], itemNome, cor, gradeNome }) => {
    if (!isVisible) return null;

    const safeTamanhosData = Array.isArray(tamanhosData) ? tamanhosData : [];
    const total = safeTamanhosData.reduce((sum, item) => sum + (Number(item.quantidade) || 0), 0);

    const modalStyle = {
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex',
        justifyContent: 'center', alignItems: 'center', zIndex: 1060
    };
    const contentStyle = {
        backgroundColor: 'white', padding: '20px', borderRadius: '8px',
        width: '90%', maxWidth: '500px', boxShadow: '0 5px 15px rgba(0,0,0,0.5)'
    };

    return (
        <div style={modalStyle}>
            <div style={contentStyle}>
                <div className="modal-header d-flex justify-content-between align-items-center p-0 pb-2 border-bottom">
                    <div>
                        <h5 className="modal-title mb-0">{gradeNome || 'Detalhes da Grade'}</h5>
                        <small className="text-muted">{itemNome} {cor && `- ${cor}`}</small>
                    </div>
                    <button type="button" className="btn-close" onClick={onClose}></button>
                </div>
                <div className="modal-body p-0 py-3" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <div className="d-flex justify-content-between mb-3 fw-bold border-bottom pb-1">
                        <span>Tamanho</span>
                        <span>Quantidade Total</span>
                    </div>
                    {safeTamanhosData.map((item, index) => (
                        <div key={item.tamanho || index} className="d-flex justify-content-between align-items-center mb-2 p-2 border-bottom">
                            <span className="fw-bold">{item.tamanho}</span>
                            <span>{item.quantidade}</span>
                        </div>
                    ))}
                    {safeTamanhosData.length === 0 && <p className='text-muted text-center'>Nenhum tamanho encontrado.</p>}
                </div>
                <div className="modal-footer p-0 pt-3 border-top d-flex justify-content-end">
                    <span className="me-auto fw-bold">TOTAL: {total}</span>
                    <button type="button" className="btn btn-secondary" onClick={onClose}>Fechar</button>
                </div>
            </div>
        </div>
    );
};

// =========================================================
// --- COMPONENTE PRINCIPAL ---
// =========================================================

function MovimentacaoForm({ onSubmit, initialData, isEditing = false }) {
    const { currentUser } = useAuth();

    // Estados da Movimentação
    const [tipo, setTipo] = useState('entrada');
    const [descricao, setDescricao] = useState('');
    // Novos Estados
    const [origem, setOrigem] = useState('');
    const [documento, setDocumento] = useState('');

    const [dataMovimentacao, setDataMovimentacao] = useState(new Date().toISOString().split('T')[0]);
    const [itens, setItens] = useState([]);

    // --- Estados para seleção de item ---
    const [todosOsItens, setTodosOsItens] = useState([]);
    const [filtroTipoItem, setFiltroTipoItem] = useState('todos');
    const [itemSelecionadoId, setItemSelecionadoId] = useState('');
    const [itemInfo, setItemInfo] = useState(null);
    const [cor, setCor] = useState('');
    const [quantidade, setQuantidade] = useState(1);

    // Estados para Grades (só para produtos)
    const [todasAsGrades, setTodasAsGrades] = useState([]);
    const [gradesDisponiveisProduto, setGradesDisponiveisProduto] = useState([]);
    const [gradeSelecionada, setGradeSelecionada] = useState('');
    const [tamanhosConfigurados, setTamanhosConfigurados] = useState([]);
    const [isTamanhoModalVisible, setIsTamanhoModalVisible] = useState(false);

    // Estados para Modal de Visualização
    const [isVisualizarModalVisible, setIsVisualizarModalVisible] = useState(false);
    const [tamanhosParaVisualizar, setTamanhosParaVisualizar] = useState([]);
    const [itemVisualizarInfo, setItemVisualizarInfo] = useState({ nome: '', cor: '', grade: '' });

    const apiCall = useCallback(async (url) => {
        if (!currentUser) throw new Error("Usuário não autenticado");
        const token = await currentUser.getIdToken();
        const API_URL = process.env.REACT_APP_API_URL;
        const response = await fetch(`${API_URL}${url}`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `Falha ao buscar ${url}`);
        }
        if (response.status === 204) return null;
        return response.json();
    }, [currentUser]);

    useEffect(() => {
        const fetchData = async () => {
            if (!currentUser) return;
            try {
                const [produtosData, insumosData, gradesData] = await Promise.all([
                    apiCall('/api/produtos').catch(err => { console.error("Erro produtos:", err); return []; }),
                    apiCall('/api/insumos').catch(err => { console.error("Erro insumos:", err); return []; }),
                    apiCall('/api/grades').catch(err => { console.error("Erro grades:", err); return []; })
                ]);

                const produtosCombinados = [
                    ...produtosData.map(p => ({
                        ...p, tipoItem: 'produto',
                        display: `${p.codigo || 'S/C'} - ${p.descricao || 'Produto sem descrição'}`
                    })),
                    ...insumosData.map(i => ({
                        ...i, tipoItem: 'insumo',
                        display: `${i.codigo || 'S/C'} - ${i.descricao || 'Insumo sem descrição'} (Insumo)`
                    }))
                ].sort((a, b) => a.display.localeCompare(b.display));

                setTodosOsItens(produtosCombinados);
                setTodasAsGrades(gradesData || []);

            } catch (err) {
                console.error("Erro geral ao buscar dados iniciais:", err);
                Swal.fire('Erro', 'Não foi possível carregar os dados necessários para a movimentação.', 'error');
            }
        };
        fetchData();
    }, [apiCall, currentUser]);

    const itensFiltrados = useMemo(() => {
        if (filtroTipoItem === 'todos') {
            return todosOsItens;
        }
        return todosOsItens.filter(item => item.tipoItem === filtroTipoItem);
    }, [todosOsItens, filtroTipoItem]);

    const handleTipoItemChange = (e) => {
        setFiltroTipoItem(e.target.value);
        setItemSelecionadoId('');
        setItemInfo(null);
    };

    const handleGradeChange = useCallback(async (gradeId) => {
        setGradeSelecionada(gradeId);
        setTamanhosConfigurados([]);
        if (!gradeId) return;
        try {
            const gradeCompleta = await apiCall(`/api/grades/${gradeId}`);
            const tamanhosParaConfig = (gradeCompleta.tamanhos || []).map(t => ({ ...t, quantidade: t.quantidade || 0 }));
            setTamanhosConfigurados(tamanhosParaConfig);
        } catch (error) {
            console.error("Erro ao carregar tamanhos da grade:", error);
            setTamanhosConfigurados([]);
        }
    }, [apiCall]);

    useEffect(() => {
        const buscarDetalhesItem = async () => {
            setItemInfo(null); setCor(''); setGradesDisponiveisProduto([]);
            setGradeSelecionada(''); setTamanhosConfigurados([]); setQuantidade(1);

            if (itemSelecionadoId) {
                const itemBase = todosOsItens.find(item => String(item.id) === itemSelecionadoId);

                if (!itemBase || (filtroTipoItem !== 'todos' && itemBase.tipoItem !== filtroTipoItem)) {
                    setItemSelecionadoId('');
                    return;
                }

                try {
                    if (itemBase.tipoItem === 'produto') {
                        const dataProduto = await apiCall(`/api/produtos/${itemSelecionadoId}`);
                        setItemInfo({
                            ...itemBase,
                            colorsList: dataProduto.colorsList || [],
                            gradesList: dataProduto.gradesList || [],
                        });
                        setGradesDisponiveisProduto(dataProduto.gradesList || []);
                        setCor('');

                        if (dataProduto.gradesList && dataProduto.gradesList.length === 1) {
                            await handleGradeChange(dataProduto.gradesList[0].id);
                        } else {
                            setGradeSelecionada(''); setTamanhosConfigurados([]);
                        }

                    } else { // É um insumo
                        const dataInsumo = await apiCall(`/api/insumos/${itemSelecionadoId}`);
                        setItemInfo({
                            ...itemBase,
                            colorsList: dataInsumo.colorsList || [],
                            gradesList: [],
                        });
                        setGradesDisponiveisProduto([]);
                        setGradeSelecionada('');
                        setTamanhosConfigurados([]);
                        setCor('');
                    }
                } catch (err) {
                    console.error(`Erro ao buscar detalhes para item ${itemSelecionadoId}:`, err);
                    Swal.fire('Erro', `Não foi possível carregar os detalhes do item selecionado. ${err.message}`, 'error');
                    setItemInfo(null);
                }
            }
        };
        if (itemSelecionadoId && todosOsItens.length > 0) {
            buscarDetalhesItem();
        } else if (!itemSelecionadoId) {
            setItemInfo(null); setCor(''); setGradesDisponiveisProduto([]);
            setGradeSelecionada(''); setTamanhosConfigurados([]); setQuantidade(1);
        }
    }, [itemSelecionadoId, todosOsItens, apiCall, handleGradeChange, filtroTipoItem]);

    useEffect(() => {
        if (isEditing && initialData?.itens && todosOsItens.length > 0) {
            setTipo(initialData.tipo);
            setDescricao(initialData.descricao || '');
            setOrigem(initialData.origem || '');
            setDocumento(initialData.documento || '');
            try {
                setDataMovimentacao(new Date(initialData.data_movimentacao).toISOString().split('T')[0]);
            } catch (e) {
                console.error("Data inválida recebida:", initialData.data_movimentacao);
                setDataMovimentacao(new Date().toISOString().split('T')[0]);
            }

            const formattedItems = initialData.itens.map(item => {
                const itemBase = todosOsItens.find(i => String(i.id) === String(item.produto_id || item.insumo_id) && i.tipoItem === item.tipo_item.toLowerCase());
                const itemDesc = itemBase ? itemBase.display : `${item.item_codigo} - ${item.item_descricao}`;

                const isGrade = item.tipo_item === 'Produto' && Array.isArray(item.tamanhos_do_item) && item.tamanhos_do_item.length > 0;
                const quantidadeTotalCalc = isGrade
                    ? (Array.isArray(item.tamanhos_do_item) ? item.tamanhos_do_item.reduce((sum, t) => sum + (Number(t.quantidade) || 0), 0) : 0) // Soma qtdes dos tamanhos (por volume)
                    * (Number(item.quantidade) || 1) // Multiplica pelos volumes
                    : Number(item.quantidade) || 0;

                return {
                    idTemp: item.id || Date.now() + Math.random(),
                    produtoId: item.produto_id,
                    insumoId: item.insumo_id,
                    itemDescricao: itemDesc,
                    tipoItem: item.tipo_item === 'Produto' ? 'produto' : 'insumo',
                    cor: item.cor,
                    gradeId: item.grade_id,
                    quantidade: item.quantidade,
                    quantidadeTotal: quantidadeTotalCalc,
                    tamanhosDoItem: Array.isArray(item.tamanhos_do_item) ? item.tamanhos_do_item : []
                };
            });
            setItens(formattedItems);
        }
    }, [isEditing, initialData, todosOsItens]);

    const handleOpenTamanhoModal = () => { if (!gradeSelecionada) { Swal.fire("Atenção", "Selecione uma grade.", "warning"); return; } setIsTamanhoModalVisible(true); };
    const handleSaveTamanhos = (tamanhosEditados) => { setTamanhosConfigurados(tamanhosEditados); setIsTamanhoModalVisible(false); };
    const handleVisualizarGrade = (item) => {
        const volumes = Number(item.quantidade) || 1;
        const safeTamanhos = Array.isArray(item.tamanhosDoItem) ? item.tamanhosDoItem : [];
        const tamanhosMultiplicados = safeTamanhos.map(t => ({ ...t, quantidade: (Number(t.quantidade) || 0) * volumes }));
        setTamanhosParaVisualizar(tamanhosMultiplicados);
        const gradeInfo = todasAsGrades.find(g => g.id === item.gradeId);
        setItemVisualizarInfo({ nome: item.itemDescricao, cor: item.cor, grade: gradeInfo?.descricao || 'Grade do Item' });
        setIsVisualizarModalVisible(true);
    };
    const handleAddItem = () => {
        if (!itemInfo || quantidade <= 0) { Swal.fire('Atenção', 'Selecione um item e informe uma quantidade válida (> 0).', 'warning'); return; }

        const tipoDoItem = itemInfo.tipoItem;
        const controlaGrade = tipoDoItem === 'produto' && itemInfo.gradesList && itemInfo.gradesList.length > 0;

        if (controlaGrade && !gradeSelecionada) { Swal.fire('Atenção', 'Este produto requer a seleção de uma grade.', 'warning'); return; }

        const quantidadeTotal = controlaGrade
            ? tamanhosConfigurados.reduce((sum, t) => sum + (Number(t.quantidade) || 0), 0) * Number(quantidade)
            : Number(quantidade);

        if (quantidadeTotal <= 0) { Swal.fire('Atenção', 'A quantidade total do item (considerando a grade, se aplicável) deve ser maior que zero.', 'warning'); return; }

        const novoItem = {
            idTemp: Date.now(),
            produtoId: tipoDoItem === 'produto' ? itemInfo.id : null,
            insumoId: tipoDoItem === 'insumo' ? itemInfo.id : null,
            itemDescricao: itemInfo.display,
            tipoItem: tipoDoItem,
            cor: cor || null,
            gradeId: controlaGrade ? gradeSelecionada : null,
            quantidade: Number(quantidade),
            quantidadeTotal: quantidadeTotal,
            tamanhosDoItem: controlaGrade ? [...tamanhosConfigurados] : []
        };

        setItens(prevItens => [...prevItens, novoItem]);

        setItemSelecionadoId(''); setItemInfo(null); setCor(''); setGradeSelecionada('');
        setTamanhosConfigurados([]); setQuantidade(1); setGradesDisponiveisProduto([]);
    };
    const handleRemoveItem = (idTemp) => { setItens(itens.filter(item => item.idTemp !== idTemp)); };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (itens.length === 0) {
            Swal.fire('Atenção', 'Adicione pelo menos um item à movimentação.', 'warning');
            return;
        }

        const itensParaApi = itens.map(item => ({
            produtoId: item.produtoId,
            insumoId: item.insumoId,
            cor: item.cor,
            gradeId: item.gradeId,
            quantidade: item.quantidade,
            tamanhosDoItem: item.tamanhosDoItem
        }));


        onSubmit({
            tipo,
            descricao,
            data_movimentacao: dataMovimentacao,
            origem,
            documento,
            itens: itensParaApi
        });
    };

    const totalItens = useMemo(() => itens.reduce((sum, item) => sum + item.quantidadeTotal, 0), [itens]);

    return (
        <>
            {isTamanhoModalVisible && itemInfo?.tipoItem === 'produto' && (<TamanhoModal isVisible={isTamanhoModalVisible} onClose={() => setIsTamanhoModalVisible(false)} tamanhosData={tamanhosConfigurados} onSave={handleSaveTamanhos} gradeNome={todasAsGrades.find(g => g.id === gradeSelecionada)?.descricao || ''} />)}
            {isVisualizarModalVisible && (<VisualizarGradeModal isVisible={isVisualizarModalVisible} onClose={() => setIsVisualizarModalVisible(false)} tamanhosData={tamanhosParaVisualizar} itemNome={itemVisualizarInfo.nome} cor={itemVisualizarInfo.cor} gradeNome={itemVisualizarInfo.grade} />)}

            <form onSubmit={handleSubmit} className="mb-5">
                <div className="form-card">
                    <h2 className="form-section-header">Dados da Movimentação</h2>
                    <div className="row g-3">
                        <div className="col-md-2">
                            <label className="form-label-custom">Tipo</label>
                            <select className="form-select-custom" value={tipo} onChange={e => setTipo(e.target.value)} disabled={isEditing}>
                                <option value="entrada">Entrada</option>
                                <option value="saida">Saída</option>
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label-custom">Data da Movimentação</label>
                            <input type="date" className="form-control-custom" value={dataMovimentacao} onChange={(e) => setDataMovimentacao(e.target.value)} required />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label-custom">Origem</label>
                            <input type="text" className="form-control-custom" value={origem} onChange={e => setOrigem(e.target.value)} placeholder="Ex: Manual, Venda..." />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label-custom">Documento</label>
                            <input type="text" className="form-control-custom" value={documento} onChange={e => setDocumento(e.target.value)} placeholder="Ex: NF-12345" />
                        </div>
                        <div className="col-12">
                            <label className="form-label-custom">Descrição / Motivo</label>
                            <input type="text" className="form-control-custom" value={descricao} onChange={e => setDescricao(e.target.value)} placeholder="Ex: Ajuste de inventário, Recebimento NF-123" />
                        </div>
                    </div>
                </div>

                <div className="form-card">
                    <h2 className="form-section-header">Adicionar Itens</h2>
                    <div className="row g-3 mb-4">
                        <div className="col-md-3">
                            <label className="form-label-custom">Tipo de Item</label>
                            <select className="form-select-custom" value={filtroTipoItem} onChange={handleTipoItemChange}>
                                <option value="todos">Produtos e Insumos</option>
                                <option value="produto">Apenas Produtos</option>
                                <option value="insumo">Apenas Insumos</option>
                            </select>
                        </div>
                        <div className="col-md-9">
                            <label className="form-label-custom">Item</label>
                            <select
                                className="form-select-custom"
                                value={itemSelecionadoId}
                                onChange={e => setItemSelecionadoId(e.target.value)}
                                disabled={!filtroTipoItem}
                            >
                                <option value="">Selecione...</option>
                                {itensFiltrados.map(item => (
                                    <option key={`${item.tipoItem}-${item.id}`} value={item.id}>
                                        {item.display}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {itemInfo && (
                        <div className="row g-3 align-items-end">

                            {itemInfo.colorsList && itemInfo.colorsList.length > 0 && (
                                <div className="col-md-3">
                                    <label className="form-label-custom">Cor</label>
                                    <select className="form-select-custom" value={cor} onChange={e => setCor(e.target.value)}>
                                        <option value="">Nenhuma</option>
                                        {itemInfo.colorsList.map(c => <option key={c} value={c}>{c}</option>)}
                                    </select>
                                </div>
                            )}

                            {itemInfo.tipoItem === 'produto' && itemInfo.gradesList && itemInfo.gradesList.length > 0 ? (
                                <>
                                    <div className="col-md-3">
                                        <label className="form-label-custom">Grade</label>
                                        <div className="input-group">
                                            <select
                                                className="form-select-custom"
                                                value={gradeSelecionada}
                                                onChange={(e) => handleGradeChange(e.target.value)}
                                                required
                                                style={{ borderRadius: '0.375rem 0 0 0.375rem' }}
                                            >
                                                <option value="">Selecione...</option>
                                                {gradesDisponiveisProduto.map(g => <option key={g.id} value={g.id}>{g.descricao}</option>)}
                                            </select>
                                            <button
                                                type="button" className="btn btn-info"
                                                onClick={handleOpenTamanhoModal} disabled={!gradeSelecionada}
                                                title="Configurar Quantidades por Tamanho"
                                                style={{ borderRadius: '0 0.375rem 0.375rem 0' }}
                                            >
                                                <i className="fa-solid fa-ruler-combined"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label-custom">Qtde. Volumes</label>
                                        <input type="number" className="form-control-custom" value={quantidade} onChange={e => setQuantidade(Math.max(1, Number(e.target.value) || 1))} min="1" />
                                    </div>
                                </>
                            ) : (
                                <div className="col-md-2">
                                    <label className="form-label-custom">Quantidade</label>
                                    <input type="number" className="form-control-custom" value={quantidade} onChange={e => setQuantidade(Math.max(1, Number(e.target.value) || 1))} min="1" />
                                </div>
                            )}

                            <div className="col-md-2">
                                <button type="button" className="btn btn-primary-custom w-100" onClick={handleAddItem}>
                                    Adicionar
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {itens.length > 0 && (
                    <div className="form-card">
                        <h2 className="form-section-header">Itens da Movimentação</h2>
                        <div className="table-responsive">
                            <table className="table-custom" style={{ width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th>Item</th> <th>Cor</th> <th>Grade</th>
                                        <th className="text-end">Qtde. Vol / Simples</th>
                                        <th className="text-end">Qtde. Total Unid.</th>
                                        <th className="text-center">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itens.map(item => (
                                        <tr key={item.idTemp}>
                                            <td>{item.itemDescricao}</td>
                                            <td>{item.cor || '—'}</td>
                                            <td>{item.tipoItem === 'produto' && item.gradeId ? (todasAsGrades.find(g => g.id === item.gradeId)?.descricao || 'N/D') : (item.tipoItem === 'produto' ? '—' : 'N/A')}</td>
                                            <td className="text-end">{item.quantidade}</td>
                                            <td className="text-end fw-bold">{item.quantidadeTotal}</td>
                                            <td className="actions-cell">
                                                {item.tipoItem === 'produto' && item.tamanhosDoItem.length > 0 && (<button type="button" className="btn-action-sm btn-edit" title="Visualizar Grade" onClick={() => handleVisualizarGrade(item)}> <i className="fa-solid fa-box-open"></i> </button>)}
                                                <button type="button" className="btn-action-sm btn-delete ms-2" onClick={() => handleRemoveItem(item.idTemp)} title="Remover Item"> <i className="fas fa-trash"></i> </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot> <tr className="fw-bold" style={{ backgroundColor: '#f8f9fa' }}> <td colSpan="4" className="p-3">Total Geral de Unidades</td> <td className="text-end p-3">{totalItens}</td> <td></td> </tr> </tfoot>
                            </table>
                        </div>
                    </div>
                )}

                <div className="form-actions-bar">
                    <div className="container-fluid d-flex justify-content-end gap-3 align-items-center">
                        <Link to="/app/movimentacoes" className="btn btn-secondary-custom">
                            Cancelar
                        </Link>
                        <button type="submit" className="btn btn-primary-custom">
                            {isEditing ? 'Atualizar Movimentação' : 'Salvar Movimentação'}
                        </button>
                    </div>
                </div>
            </form >
        </>
    );
}

export default MovimentacaoForm;
